import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { MultiSelect as MS } from 'primereact/multiselect';

import LabelName from 'components/UI/LabelName/LabelName';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import SubText from '../FormComponenets/SubText';
import OptionValidator from '../FormComponenets/OptionValidator';

export default function MultiSelect({
  handleSettingsClick,
  item,
  index,
  isFormBuilder,
  relationFieldName,
  isRelation = false,
  isFromPreview = false,
}) {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { subtext, label, required, options = [] } = item || {};
  const name = isRelation ? relationFieldName : `form_data.${index}.value`;

  return (
    <div className="w-100">
      <LabelName>
        {label}
        {required && <span className="danger-text"> *</span>}
      </LabelName>
      <div className="d-flex align-items-center flex-wrap">
        <Controller
          name={name}
          control={control}
          rules={isFormBuilder ? {} : { required: required ? 'Required Field' : false }}
          render={({ field, fieldState }) => (
            <MS
              id={field.name}
              options={options}
              optionLabel="label"
              optionValue="value"
              display="chip"
              onChange={(e) => field.onChange(e.value)}
              value={field.value || []} // Default to an empty array if no value
              placeholder="Select options"
              className={classNames({ 'p-invalid': fieldState.invalid, 'w-100 input-shadow': true })}
              style={{ pointerEvents: isFormBuilder || isFromPreview ? 'none' : 'auto' }}
              inputRef={isFormBuilder ? null : field.ref}
            />
          )}
        />
        <SubText {...{ subtext, handleSettingsClick, item, isFormBuilder }} />
        {isFormBuilder && item?.res_type !== 'custom-field' && (
          <span className="add-option" onClick={() => handleSettingsClick(item)}>
            + Add Options
          </span>
        )}
        {isFormBuilder && item?.res_type !== 'custom-field' && <OptionValidator name={`form_data.${index}.options`} />}
      </div>
      <RequiredValidation field={name} errors={errors} />
    </div>
  );
}
